<template>
  <div class="ProcessExceptionPreview">
    <el-tabs :value="tabActive">
      <el-tab-pane name="first" label="异常信息">
        <div>
          <el-button type="primary" @click="printPage">打印</el-button>
        </div>
        <div class="WrongInfoPage">
          <h1 class="mainTitle">eMES异常处理通知单</h1>
          <div class="title"/>
          <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">系统编号:</td>
              <td>{{processException.billNo}}</td>
              <td class="tableLabel">开单人:</td>
              <td>{{processException.creatorName}}</td>
              <td class="tableLabel">登记日期:</td>
              <td>{{processException.createTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">开单部门:</td>
              <td>{{processException.department}}</td>
              <td class="tableLabel">出厂编号:</td>
              <td>{{processException.factoryNo}}</td>
              <td class="tableLabel">客户名称:</td>
              <td>{{processException.customerName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">是否处理:</td>
              <td v-if="processException.isHandle===true">是</td>
              <td v-else>否</td>
              <td class="tableLabel">处理部门接口人:</td>
              <td>{{processException.handleName}}</td>
              <td class="tableLabel">质量部接口人:</td>
              <td>{{processException.qualityDirecterName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">工时:</td>
              <td>{{processException.workTime}}</td>
              <td class="tableLabel">序列号:</td>
              <td>{{processException.serialNo}}</td>
            </tr>
            <tr>
              <td class="tableLabel">问题描述:</td>
              <td colspan="5">{{processException.problemDesc}}</td>
            </tr>
          </table>
          <div>
            <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单物料</div>
            <el-table :data="processException.processExceptionMaterialVOS">
              <el-table-column label="物料编号" align="left" prop="materialNo"/>
              <el-table-column label="物料描述" align="left" prop="materialName"/>
              <el-table-column label="不良数量" align="left" prop="badNum"/>
            </el-table>
          </div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
          <el-table :data="processException.accessories">
            <el-table-column label="文件名称" align="left" prop="fileName"/>
            <el-table-column label="备注" align="left" prop="note"/>
            <el-table-column label="操作" align="center" width="90">
              <template slot-scope="scope">
                <el-button type="primary" @click="downloadFile(scope.row.filePath)">查看附件</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
      </el-tab-pane>
      <el-tab-pane name="second" label="处理部门">
        <div class="title"/>
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">不合格品处理方式:</td>
            <td>{{processException.processMode}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="third" label="质量判责">
        <div class="title"/>
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">质量判责结果:</td>
            <td>{{processException.judgmentResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任部门:</td>
            <td>{{processException.responsibleDepartment}}</td>
          </tr>
          <tr>
            <td class="tableLabel">供应商名称:</td>
            <td>{{processException.supplierName}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="fourth" label="维修处理结果">
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">检查结果:</td>
            <td>{{processException.inspectionResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">处理方法:</td>
            <td>{{processException.solution}}</td>
          </tr>
          <tr>
            <td class="tableLabel">故障模块分类:</td>
            <td>{{processException.faultType}}</td>
          </tr>
          <tr>
            <td class="tableLabel">电机问题类型:</td>
            <td>{{processException.problemType}}</td>
          </tr>
          <tr>
            <td class="tableLabel">原因分析:</td>
            <td>{{processException.causeInvestigation}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任判定:</td>
            <td>{{processException.responsibleDecision}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
  </div> 
</template>

<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  export default {
    name:"ProcessExceptionsPreview",
    components:{ HandleDetail},
    data() {
      return {
        billId:"",
        billType:"24",
        tabActive:"first",
        processException:[],
      };
    },
    created() {
      console.log(this.$route.query.billId);
      this.billId = this.$route.query.billId;
      this.getData();
    },
    methods:{
      getData() {
        this.$http.get("basic",`processExceptions/${this.billId}`).then((res)=>{
          console.log(res);
          this.processException = res;
        });
      },
      downloadFile(path) {
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + path;
        a.target = "_blank";
        a.download = path;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      printPage() {
        var printPage = document.querySelector(".WrongInfoPage").innerHTML;
        var oldPage = document.body.innerHTML;
        document.body.innerHTML = printPage;
        window.print();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss">
  .ProcessExceptionTable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  .ProcessExceptionTable1{
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-left: 1px solid #ebeef5;
  }
  table.ProcessExceptionTable1 th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProcessExceptionTable1 td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    border-left: none;
    border-bottom: none;
  }
  table.ProcessExceptionTable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProcessExceptionTable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    border-left: none;
    border-bottom: none;
  }
  .tableLabel {
    width: 15%;
    text-align: right;
    background-color: #d1e6f5 !important;
  }
  .title {
   font-size:12px;
   font-weight:550;
   border-bottom:1px solid #ccc;
   width:100%;
   margin:5px 0 5px;
  }
  .mainTitle {
    font-size: 20px;
    line-height: 20px;
    text-align: center;
  }
</style>